import { styled } from '../../Styles/stitches.config'

export const StyledStars = styled('img', {
    aspectRatio: 512 / 96,

    variants: {
        size: {
            xs: {
                h: 12,
            },
            s: {
                h: 14,
            },
            m: {
                h: 16,
            },
            l: {
                h: 18,
            },
            xl: {
                h: 20,
            },
        },
    },

    defaultVariants: { size: 'm' },
})
